module.exports = __webpack_public_path__ + "34c791ef1f41eedb26b8c05c87de789c.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/soffa_desk_gray.gif
 ** module id = 461
 ** module chunks = 0
 **/